import {
    isFeatureEnabled,
    toFeatureState,
} from '@west-australian-newspapers/etrigan-feature-toggles-client'
import {
    Intention,
    LinkClickedEvent,
    useToggleState,
} from '@news-mono/web-common'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { StyledParagraph } from '../../publication/Paragraph/Paragraph.styled'
import { useProduct } from '../../__product'
import { TtsWordInParagraph } from '../TtsText'

export interface ParagraphProps {
    text: string
    intentions?: Intention[]
    tag?: 'p'
    onEvent: (event: LinkClickedEvent) => void
    className?: string
    briefPrefix?: string
    ttsWords?: TtsWordInParagraph[]
    currentWordIndex?: number
    isPlaying?: boolean
}

export const Paragraph: React.FC<ParagraphProps> = (props) => {
    const toggles = useToggleState()
    const product = useProduct()
    const location = useLocation()

    const sevenYouToggle = isFeatureEnabled(
        toFeatureState(toggles),
        '7-news-7-you-page',
    )
    const pathPrefix = sevenYouToggle ? '/7you' : '/best-picks'
    const isNoFollow =
        product &&
        location &&
        product === 'sevennews' &&
        location.pathname.startsWith(pathPrefix)

    const isFontIncreasedOnTheWestArticle = isFeatureEnabled(
        toFeatureState(toggles),
        'the-west-increased-article-font',
    )
    const [isIncreasedFont, setFontIncrease] = useState(false)

    useEffect(() => {
        setFontIncrease(isFontIncreasedOnTheWestArticle)
    }, [isFontIncreasedOnTheWestArticle])

    // For TheNightly: append kicker text as prefix to live articles
    const applyBriefPrefix = !!props.briefPrefix && product === 'thenightly'
    const prefixText = applyBriefPrefix ? `${props.briefPrefix}: ` : ''
    const text = `${prefixText}${props.text}`
    const leadingWhitespaceLen =
        typeof props.text === 'string'
            ? props.text.length - props.text.trimStart().length
            : 0

    const intentions = [
        // Add intention for the brief prefix text
        ...(applyBriefPrefix
            ? [
                  {
                      kind: 'important',
                      index: 0,
                      length: props.briefPrefix!.length,
                  },
              ]
            : []),
        // Shift the index to account for the added prefix in the text
        ...(props.intentions?.map((intent) => {
            if (!applyBriefPrefix) return intent
            return { ...intent, index: intent.index + prefixText.length }
        }) || []),
    ]
    return (
        <StyledParagraph
            tag="p"
            text={text}
            intentions={intentions}
            onEvent={props.onEvent}
            isIncreasedFont={isIncreasedFont}
            isNoFollow={isNoFollow}
            isBriefParagraph={!!props.briefPrefix}
            ttsWords={props.ttsWords}
            briefPrefixLength={prefixText.length}
            ttsOffsetShift={leadingWhitespaceLen}
            currentWordIndex={props.currentWordIndex}
            isPlaying={props.isPlaying}
        />
    )
}
Paragraph.displayName = 'Paragraph'
